(function () {
  function qs(root, sel) { return root.querySelector(sel); }

  function getVariantId(section) {
    const idInput = qs(section, 'form[action*="/cart/add"] input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getQuantity(section) {
    const qtyInput = qs(section, 'input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity,
        properties: {
          '_gt_requires_holders': '1'
        }
      })
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  function init() {
    document.querySelectorAll('.gt-continue').forEach((btn) => {
      const section = btn.closest('section') || document;

      btn.addEventListener('click', async function () {
        const variantId = getVariantId(section);
        if (!variantId) return;

        const qty = getQuantity(section);

        btn.disabled = true;
        try {
          await addToCart(variantId, qty);
          
          // Kijk of er een taalcode (zoals /nl/) in de huidige adresbalk staat
          const pathMatch = window.location.pathname.match(/^\/([a-z]{2}(-[a-z]{2})?)\//);
          const langPrefix = pathMatch ? pathMatch[0] : '/';
          
          // Stuur de klant door, inclusief de juiste taal
          window.location.href = langPrefix + 'pages/ticket-holder-details';
          
        } catch (e) {
          console.error(e);
          btn.disabled = false;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
